// React
import { Col, Row } from 'reactstrap';
import React, { useEffect, useState } from 'react';

// Containers Injections
import { APIClient } from '../../../../helpers/helpersInjection';
import { CredentialsNTInjection } from '../../../../containers/credentialsNTInjection';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Components
import { ModalShowHistoric } from './components/ModalShowHistoric';
import { DatatableSchedule } from './components/DatatableSchedule';
import { ModalVisitSchedule } from './components/ModalVisitSchedule';
import { ModalMarkAsRealized } from './components/ModalMarkAsRealized';

export const VisitSchedule = ({ credential }) => {
  const [historic, setHistoric] = useState(null);
  const [idRealized, setIdRealized] = useState(0);
  const [scheduleById, setScheduleById] = useState(null);
  const [modalSchedule, setModalSchedule] = useState(false);
  const [modalRealized, setModalRealized] = useState(false);
  const [modalHistoric, setModalHistoric] = useState(false);
  function toggleModalSchedule() {
    setScheduleById(null);
    setModalSchedule(!modalSchedule);
  }

  function toggleModalRealized(values) {
    setModalRealized(!modalRealized);
    if (values) {
      setIdRealized(values.id);
    }
  }

  function toggleModalHistoric(values) {
    setModalHistoric(!modalHistoric);
    if (values) {
      setHistoric(values);
    }
  }

  const {
    schedule,
    getSchedule,
    createSchedule,
    updateSchedule,
    updateScheduleRealized,
    deleteSchedule,
    success_schedule,
  } = CredentialsNTInjection();

  const api = new APIClient();

  const convertDateToBrazilFormat = (date) => {
    let rawDate = date.slice(0, 10);

    if (rawDate !== null) {
      const [year, month, day] = rawDate.split('-');

      const result = [day, month, year].join('/');
      return result;
    }
    return null;
  };

  const getScheduleById = async (id) => {
    const response = await api.get(`/register/provider-history/${id}`);

    if (response) {
      return {
        id: response.id,
        contact_name: response.contact_name,
        visit_date: response.visit_date.slice(0, 10),
        phones: JSON.parse(response.phones),
      };
    }
  };

  const handleEdit = async (values) => {
    toggleModalSchedule();
    const data = await getScheduleById(values.id);
    setScheduleById(data);
  };

  const handleDelete = (id) => {
    deleteSchedule(id);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Agendado para</span>,
      sortable: true,
      width: '15%',
      selector: (cell) => {
        return (
          <ul
            className="list-inline hstack gap-2 mb-0 "
            style={{
              width: '100%',
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <li className="list-inline-item" title="Remove">
              {convertDateToBrazilFormat(cell.visit_date)}
            </li>
          </ul>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Contato</span>,
      selector: (row) => row.contact_name,
      sortable: true,
      width: '15%',
    },
    {
      name: <span className="font-weight-bold fs-13">Telefone</span>,
      selector: (row) => (row.phones ? row.phones.phone1 : ''),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      sortable: true,
      width: '15%',
      selector: (cell) => {
        return <span className={cell.status.color}>{cell.status.title}</span>;
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Realizado por</span>,
      selector: (row) => row.performed_by,
      sortable: true,
      width: '15%',
    },
    {
      name: <span className="font-weight-bold fs-13">Atualizado</span>,
      sortable: true,
      selector: (cell) => {
        return (
          <span className="badge badge-soft-primary">
            {cell.has_changes ? 'Sim' : cell.has_changes === null ? '' : 'Não'}
          </span>
        );
      },
    },
  ];

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      visitDateInput: scheduleById ? scheduleById.visit_date : '',
      contactInput: scheduleById ? scheduleById.contact_name : '',
      telInput:
        scheduleById && scheduleById.phones ? scheduleById.phones.phone1 : '',
      telInput2:
        scheduleById && scheduleById.phones ? scheduleById.phones.phone2 : '',
    },
    validationSchema: Yup.object({
      visitDateInput: Yup.string().required(),
      contactInput: Yup.string().required(),
      telInput: Yup.string().required('Telefone é obrigatório'),
      telInput2: Yup.string(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        provider_id: credential.id || null,
        visit_date: values.visitDateInput || null,
        contact_name: values.contactInput || null,
        phones:
          {
            phone1: values.telInput.replace(/\s/g, ''),
            phone2: values.telInput2.replace(/\s/g, ''),
          } || null,
      };

      if (scheduleById) {
        updateSchedule(scheduleById.id, valuesToSubmit);
      } else {
        createSchedule(valuesToSubmit);
      }
      toggleModalSchedule();
      validation.resetForm();
    },
  });

  useEffect(() => {
    if (credential) {
      getSchedule(credential.id);
    }
  }, [success_schedule, credential]);

  return (
    <React.Fragment>
      <Row>
        <Col
          xs={12}
          style={{
            marginTop: -24,
          }}
        >
          <DatatableSchedule
            isCard
            perPage={10}
            columns={columns}
            keySearch={'contact_name'}
            titleButton="Novo Agendamento"
            data={schedule ? schedule : []}
            title="Agenda de Visitas"
            pagination
            persistTableHead
            paginationServer
            handleButton={toggleModalSchedule}
            handleEdit={(cellProps) => handleEdit(cellProps)}
            handleDelete={(cellProps) => handleDelete(cellProps.id)}
            toggleModalRealized={(cellProps) => toggleModalRealized(cellProps)}
            toggleModalHistoric={(cellProps) => toggleModalHistoric(cellProps)}
          />
        </Col>
      </Row>

      <ModalVisitSchedule
        isOpen={modalSchedule}
        validation={validation}
        toggle={toggleModalSchedule}
        handleBack={toggleModalSchedule}
        id={scheduleById ? scheduleById.id : null}
      />

      <ModalMarkAsRealized
        isOpen={modalRealized}
        idRealized={idRealized}
        toggle={toggleModalRealized}
        handleBack={toggleModalRealized}
        updateScheduleRealized={updateScheduleRealized}
      />

      <ModalShowHistoric
        historic={historic}
        isOpen={modalHistoric}
        toggle={toggleModalHistoric}
        handleBack={toggleModalHistoric}
      />
    </React.Fragment>
  );
};
